import React from 'react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { FormButtons } from '../FormButtons';
import { OptionSelector } from '../OptionSelector';
export const SchuifwandTypeStep: React.FC = () => {
  const {
    formData,
    handleOptionSelect,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Type schuifwand" description="Kies het type schuifwand dat u wenst." isActive={true} data-id="element-1126">
      <OptionSelector options={[{
      id: 'aluminium',
      name: 'Aluminium schuifwand',
      description: 'Duurzaam, onderhoudsarm en strak design',
      icon: <svg className="h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1128">
                <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="2" data-id="element-1129" />
                <path d="M12 3V21" stroke="currentColor" strokeWidth="2" data-id="element-1130" />
                <path d="M8 12H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1131" />
                <path d="M14 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1132" />
              </svg>
    }, {
      id: 'glas',
      name: 'Glazen schuifwand',
      description: 'Maximale transparantie en lichtinval',
      icon: <svg className="h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1133">
                <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="2" data-id="element-1134" />
                <line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" strokeWidth="2" data-id="element-1135" />
                <line x1="8" y1="12" x2="10" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1136" />
                <line x1="14" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1137" />
              </svg>
    }, {
      id: 'vouwwand',
      name: 'Vouwwand',
      description: 'Volledig te openen voor maximale ruimte',
      icon: <svg className="h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1138">
                <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="2" data-id="element-1139" />
                <path d="M3 3L8 21" stroke="currentColor" strokeWidth="2" data-id="element-1140" />
                <path d="M8 3L13 21" stroke="currentColor" strokeWidth="2" data-id="element-1141" />
                <path d="M13 3L18 21" stroke="currentColor" strokeWidth="2" data-id="element-1142" />
              </svg>
    }]} selectedOption={formData.schuifwandType} onSelect={option => handleOptionSelect('schuifwandType', option)} columns={3} data-id="element-1127" />
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.schuifwandType} data-id="element-1143" />
    </FormStep>;
};